import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-inline-list',
  templateUrl: './inline-list.component.html',
  styleUrls: ['./inline-list.component.scss'],
  inputs: ['listItems']
})
export class InlineListComponent implements OnInit {

  @Input() listItems: string[];

  constructor() { }

  ngOnInit() {
  }

}
